import { createApp } from 'vue';
import App from './app.vue';
import '@library/styles/index.scss';
import developTool_Share from '@components/developTool_Share';
import { getQueryString } from '@activity-business/h5-package-frameworkTool';
import developTool from '@components/developTool_TS/index';
import {Pretreatment} from "@library/activity_pretreatment/index";

const app = createApp(App);
const rootDom = document.createElement('div');
rootDom.setAttribute('id', 'root');
document.body.appendChild(rootDom);

const countryList = ["JP","TW"];
//  第一个国家、地区码为默认值
const pretreatment = new Pretreatment(app, countryList);

pretreatment.init().then(({ profile, LANG }) => {
    app.use(developTool_Share, {
        activityId: 11299,
        // 分享落地页是站外，只能从链接上获取lang
        countryCode: getQueryString('lang'),
        componentConfig: {
            // 图片资源文件名
            image: { p: "regular_crowdFundingJP" }
        }
    }).mount(rootDom);
});

